import { Injectable } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

import { DateTimeFormatService } from '@ib-shared/services/date-time-format.service';

@Injectable()
export class CustomDateAdapter extends MomentDateAdapter {
  constructor(private _dateTimeService: DateTimeFormatService) {
    super('en-GB'); // set default locale
  }

  public format(date: moment.Moment): string {
    return date.format(this._dateTimeService.dateFormatForUi);
  }
}
